import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

const ReceiptViewer = () => {
  const [error, setError] = useState('');
  
  useEffect(() => {
    const fetchReceipt = async () => {
      // Get the token from the URL path: /v/abc123xyz
      const pathParts = window.location.pathname.split('/');
      const token = pathParts[pathParts.length - 1];
      
      if (!token) {
        setError('קישור לא תקין או חסר.');
        return;
      }

      try {
        const q = query(collection(db, 'receipts'), where('shareToken', '==', token));
        const querySnapshot = await getDocs(q);
        
        if (querySnapshot.empty) {
          // Fallback check - if it's an old receipt without a share token, maybe it's just the receiptNumber?
          // If the user literally changed /v/105 to /v/abc, we could fallback to checking receiptNumber just in case
          // but the instructions said "secure tokens" so we assume it only works for tokens.
          setError('הקבלה לא נמצאה או שהקישור פג תוקף.');
          return;
        }

        const receiptDoc = querySnapshot.docs[0].data();
        
        // Redirect to the actual Firebase PDF url
        if (receiptDoc.fileUrl) {
          window.location.href = receiptDoc.fileUrl;
        } else {
          setError('לא נמצא קובץ מקושר.');
        }

      } catch (err) {
        console.error('Error fetching receipt:', err);
        setError('אירעה שגיאה בטעינת הקבלה. נסה שוב מאוחר יותר.');
      }
    };
    
    fetchReceipt();
  }, []);

  return (
    <div style={{ padding: '60px 20px', textAlign: 'center', direction: 'rtl', fontFamily: 'sans-serif', minHeight: '100vh', backgroundColor: '#f7f9fc' }}>
      {error ? (
        <h2 style={{ color: '#e53e3e' }}>{error}</h2>
      ) : (
        <div>
          <h2 style={{ color: '#4a5568' }}>טוען קבלה... נא להמתין.</h2>
          <div style={{ marginTop: '20px', width: '40px', height: '40px', border: '4px solid #cbd5e0', borderTop: '4px solid #3182ce', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      )}
    </div>
  );
};

export default ReceiptViewer;
